import React from "react";
import PropTypes from "prop-types";
import { AddAction } from "components/buttons";
import { Restricted, permissions } from "components/auth";

const ActionButtons = ({ contractId }) => (
  <Restricted permissions={[permissions.roomtemplate_manage]}>
    <AddAction url={`/roomTemplate/new/contractId/${contractId}`} />
  </Restricted>
);

ActionButtons.propTypes = {
  /**
   * Id del contrato
   **/
  contractId: PropTypes.string,
};

export default ActionButtons;
